import styled from 'styled-components';
import COLORS from '../../common/styles/color-pallete';
import DEVICES from '../../common/styles/devices';
import { FONT_FAMILY } from '../../common/styles/fontStyles';

export const HeaderConatiner = styled.div`
  .headerImageContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: -35px;
    img {
      margin: 0;
    }
    .progress {
      margin: 6px 0 0 0 !important;
      width: 136px;
      height: 4px !important;
      .bar {
        width: 51px;
        height: 4px !important;
        background: ${COLORS.dividerBlue} !important;
      }
    }
    .stepNumber {
      color: ${COLORS.textLightGrey};
      margin-top: 8px;
      font-size: 12px;
      font-weight: 400;
    }
  }

  .headerTextContainer {
    width: 450px;
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    .headingText {
      color: ${COLORS.black};
      font-family: ${FONT_FAMILY.hellix.bold};
      font-size: 28px;
      line-height: 38px;
    }
    .headingDescription {
      color: ${COLORS.textGrey};
      width: 450px;
      margin-top: 8px;
      line-height: 22px;
      font-weight: 400;
      font-size: 16px;
      text-align: center;
    }
  }

  @media ${DEVICES.mobileXL} {
    .headerTextContainer {
      width: 400px !important;
      .headingText {
        font-size: 23px;
      }
      .headingDescription {
        width: 350px;
        font-size: 14px;
      }
    }
  }

  @media ${DEVICES.mobileL} {
    .headerTextContainer {
      width: 350px !important;
    }
  }

  @media ${DEVICES.mobileM} {
    .headerTextContainer {
      width: 300px !important;
      .headingText {
        font-size: 23px;
      }
      .headingDescription {
        width: 300px;
        font-size: 14px;
      }
    }
  }
  @media ${DEVICES.mobileS} {
    .headerTextContainer {
      width: 250px !important;
      .headingText {
        font-size: 23px;
      }
      .headingDescription {
        width: 250px;
        font-size: 14px;
      }
    }
  }
`;
